export class Fornecedor {}
